import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { useAssetLibrary } from '@/context/AssetLibraryContext'
import { useSettings } from '@/context/SettingsContext'
import { AssetLibraryDrawer } from './AssetLibraryDrawer'
import { SettingsDialog } from './SettingsDialog'
import { Sidebar } from './Sidebar'
import { TopBar } from './TopBar'

export function AppShell() {
  const { settings } = useSettings()
  // 素材库抽屉的开关归 AssetLibraryContext（pickOne 也要能打开它），
  // 这里不再自己拿一份 state —— 两份状态就是这个 bug 的来源
  const { openDrawer } = useAssetLibrary()
  const [settingsOpen, setSettingsOpen] = useState(false)

  return (
    <div className="shell" data-collapsed={settings.sidebarCollapsed}>
      <Sidebar />
      <div className="main">
        <TopBar onOpenAssets={openDrawer} onOpenSettings={() => setSettingsOpen(true)} />
        <Outlet />
      </div>
      <AssetLibraryDrawer />
      <SettingsDialog open={settingsOpen} onClose={() => setSettingsOpen(false)} />
    </div>
  )
}
